import { render, staticRenderFns } from "./userAuthOld.vue?vue&type=template&id=997bb39c"
import script from "./userAuthOld.vue?vue&type=script&lang=js"
export * from "./userAuthOld.vue?vue&type=script&lang=js"
import style0 from "./userAuthOld.vue?vue&type=style&index=0&id=997bb39c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports